import { render, staticRenderFns } from "./EntityBooleanField.vue?vue&type=template&id=374ddd91&scoped=true&lang=pug&"
import script from "./EntityBooleanField.vue?vue&type=script&lang=js&"
export * from "./EntityBooleanField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374ddd91",
  null
  
)

export default component.exports